import { render, staticRenderFns } from "./viewRemittanceTransaction.vue?vue&type=template&id=680ca20a&scoped=true&"
import script from "./viewRemittanceTransaction.vue?vue&type=script&lang=js&"
export * from "./viewRemittanceTransaction.vue?vue&type=script&lang=js&"
import style0 from "./viewRemittanceTransaction.vue?vue&type=style&index=0&id=680ca20a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680ca20a",
  null
  
)

export default component.exports